// src/AudioSpectrum/effects/flowerFountain.js
import { getHSLColor } from '../colorUtils.js';

export const drawFlowerFountain = (ctx, frequencyData, width, height, fountainRef) => {
  ctx.fillStyle = 'rgba(10, 5, 20, 0.08)';
  ctx.fillRect(0, 0, width, height);
  
  const fountainCount = 4;
  const fountainWidth = width / fountainCount;
  
  for (let f = 0; f < fountainCount; f++) {
    const fountainX = (f + 0.5) * fountainWidth;
    const freqStart = Math.floor((f / fountainCount) * frequencyData.length);
    const freqEnd = Math.floor(((f + 1) / fountainCount) * frequencyData.length);
    const avgValue = frequencyData.slice(freqStart, freqEnd).reduce((a, b) => a + b, 0) / (freqEnd - freqStart);
    
    if (avgValue > 40) {
      const petalCount = Math.floor(avgValue / 25);
      for (let i = 0; i < petalCount; i++) {
        fountainRef.current.push({
          x: fountainX + (Math.random() - 0.5) * 30,
          y: height - 80,
          vx: (Math.random() - 0.5) * 3,
          vy: -(avgValue / 255) * 10 - Math.random() * 3,
          life: 1.0,
          decay: 0.006,
          size: Math.random() * 3 + 2,
          color: getHSLColor(Math.random() * 60 + 280, 80, 70),
          gravity: 0.08,
          trail: [],
          rotation: Math.random() * Math.PI * 2,
          rotationSpeed: (Math.random() - 0.5) * 0.3,
          type: 'petal'
        });
      }
    }
  }
  
  // 꽃잎 파티클 업데이트
  fountainRef.current = fountainRef.current.filter(particle => {
    particle.x += particle.vx;
    particle.y += particle.vy;
    particle.vy += particle.gravity;
    particle.vx *= 0.998;
    particle.life -= particle.decay;
    particle.rotation += particle.rotationSpeed;
    
    if (particle.life > 0 && particle.y < height + 50) {
      ctx.globalAlpha = particle.life;
      ctx.save();
      ctx.translate(particle.x, particle.y);
      ctx.rotate(particle.rotation);
      
      // 꽃잎 모양 그리기
      ctx.fillStyle = particle.color;
      ctx.beginPath();
      for (let i = 0; i < 5; i++) {
        const angle = (i * Math.PI * 2) / 5;
        const petalX = Math.cos(angle) * particle.size;
        const petalY = Math.sin(angle) * particle.size * 0.6;
        if (i === 0) ctx.moveTo(petalX, petalY);
        else ctx.lineTo(petalX, petalY);
      }
      ctx.closePath();
      ctx.fill();
      
      // 중앙 점
      ctx.fillStyle = getHSLColor(50, 80, 80);
      ctx.beginPath();
      ctx.arc(0, 0, particle.size * 0.3, 0, Math.PI * 2);
      ctx.fill();
      
      ctx.restore();
      ctx.globalAlpha = 1.0;
      return true;
    }
    return false;
  });
};